import { ImageViewer, type ImageSource } from '@powerportalspro/react-fluent';

const source: ImageSource = { kind: 'url', value: 'https://placehold.co/800x600.png' };

export function ImageViewerToolbarSample() {
  return (
    <ImageViewer
      source={source}
      fileName="placeholder.png"
      toolbar
      downloadable
      style={{ width: '100%', maxWidth: '800px' }}
    />
  );
}
